import { townAndAirportData } from '@/types/api/town-and-airports'

export const GERMAN_CITY_NAMES: Record<string, string[]> = {
  warsaw: ['warschau'],
  cracow: ['krakau'],
  gdansk: ['danzig'],
  poznan: ['posen'],
  wroclaw: ['breslau'],
  katowice: ['kattowitz'],
  szczecin: ['stettin'],
  swinoujscie: ['swinemünde', 'swinemunde'],
  lodz: ['lodz'],
  bydgoszcz: ['bromberg']
}

export interface LocationContext {
  isAirport: boolean
  cityKey?: string
  cityUrlSlug?: string
  airportCode?: string
  cityName?: string
  airportName?: string
  locativeForm?: string
}

export function getLocationContext(
  locationLabel: string,
  market = 'pl'
): LocationContext {
  if (!locationLabel) {
    return { isAirport: false }
  }

  const regionData = townAndAirportData[market]
  if (!regionData) {
    return { isAirport: false }
  }

  for (const town of regionData.towns) {
    if (town.airports) {
      for (const airport of town.airports) {
        if (
          locationLabel.includes(airport.code) ||
          locationLabel.toLowerCase().includes(airport.name.toLowerCase())
        ) {
          return {
            isAirport: true,
            cityKey: town.key,
            cityUrlSlug: town.cityUrlSlug,
            airportCode: airport.code,
            cityName: town.name,
            airportName: airport.name,
            locativeForm: town.locativeForm
          }
        }
      }
    }

    const locationLower = locationLabel.toLowerCase()
    const townNameLower = town.name.toLowerCase()
    const townKeyLower = town.key.toLowerCase()

    const basicMatch =
      locationLower.includes(townNameLower) ||
      locationLower.includes(townKeyLower)

    const krakowMatch =
      town.key === 'cracow' &&
      (locationLower.includes('krakow') ||
        locationLower.includes('cracow') ||
        locationLower.includes('kraków'))

    const germanMatch =
      GERMAN_CITY_NAMES[town.key]?.some((germanName: string) =>
        locationLower.includes(germanName.toLowerCase())
      ) || false

    if (basicMatch || krakowMatch || germanMatch) {
      return {
        isAirport: false,
        cityKey: town.key,
        cityUrlSlug: town.cityUrlSlug,
        cityName: town.name,
        locativeForm: town.locativeForm
      }
    }
  }

  return { isAirport: false }
}
